import { createFileRoute, redirect } from "@tanstack/react-router"

/**
 * Redirect route that forwards /settings/stores/$storeId/files to /files?storeId=$storeId
 * This provides a convenient deep link from store settings to their files.
 */
export const Route = createFileRoute("/(authenticated)/settings/stores/$storeId/files")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/files",
      search: {
        storeId: params.storeId,
      },
    })
  },
})
